import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState,
} from 'recompose';
import { renderNothingIfPropFalsy } from 'utils/recompose';
import PropTypes from 'prop-types';

const propTypes = {
  dropdownOpen: PropTypes.bool.isRequired,
  selectOption: PropTypes.func.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
};

export const onRef = ({ setRef }) => dropdownRef => {
  setRef(dropdownRef);
};

export const handleClick = ({
  selectOption,
  toggleDropdown,
}) => compModelCode => () => {
  selectOption(compModelCode);
  toggleDropdown();
};

export const onClickOutside = ({ dropdownRef, toggleDropdown }) => event =>
  dropdownRef && !dropdownRef.contains(event.target) && toggleDropdown();

function componentDidMount() {
  document.addEventListener('mousedown', this.props.onClickOutside);
}

function componentWillUnmount() {
  document.removeEventListener('mousedown', this.props.onClickOutside);
}

export default compose(
  setPropTypes(propTypes),
  withState('dropdownRef', 'setRef', null),
  withHandlers({ onClickOutside, handleClick, onRef }),
  lifecycle({
    componentDidMount,
    componentWillUnmount,
  }),
  renderNothingIfPropFalsy('dropdownOpen'),
);
